export default __webpack_public_path__ + "static/media/200.a7d9619c.woff";